import { AccordionV1IsEmptyFn } from '@adobe/aem-core-components-react-spa';
import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '../../common';
import Accordion from './Accordion';
const accordionEditConfig = {
    emptyLabel: 'Accordion',
    isEmpty: AccordionV1IsEmptyFn,
};
export default MapTo(AEM_FUNCTIONS.accordion)(Accordion, accordionEditConfig);
